import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useTheme } from '../../theme/ThemeProvider';

/**
 * ThemeToggle Component
 * 
 * A button to toggle between light and dark mode.
 * Uses the theme context to manage state.
 * 
 * @example
 * <ThemeToggle />
 */
export default function ThemeToggle() {
  const { mode, toggleMode } = useTheme();
  
  return (
    <Tooltip title={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}>
      <IconButton
        onClick={toggleMode}
        color="inherit"
        aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}
        size="large"
      >
        {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  );
}
